module.exports = {
          srcSet: __webpack_public_path__ + "542bc834486805065d22c86798b919aa-36.png"+" 36w",
          images:[ {path: __webpack_public_path__ + "542bc834486805065d22c86798b919aa-36.png",width: 36,height: 37}],
          src: __webpack_public_path__ + "542bc834486805065d22c86798b919aa-36.png",
          toString:function(){return __webpack_public_path__ + "542bc834486805065d22c86798b919aa-36.png"},
          
          width: 36,
          height: 37
        }